import { ChangeColor } from './ChangeColor';

export class ChangeLightColor extends ChangeColor {
  type: string = 'ChangeLightColor';
}
